/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Orders_MonthInputs */

const vi_dashboard_orders_month = /** @type {(inputs: Dashboard_Orders_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn hàng tháng`)
};

/**

* @param {Dashboard_Orders_MonthInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_orders_month = /** @type {((inputs?: Dashboard_Orders_MonthInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Orders_MonthInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_orders_month(inputs)
});